import "@babel/polyfill"
import React from 'react'
import ReactDOM from 'react-dom/client'
import DayPicker from 'react-day-picker'
import moment from 'moment'
import Modal from 'react-modal'

import CalendarStyle from '../common/constants/calendar_style'
import Mixpanel from '../common/mixpanel'

import $ from 'jquery'

document.addEventListener('DOMContentLoaded', () => {
  if ($('#availability-calendar').length) {
    const $availability = $('#availability-calendar');

    const root = ReactDOM.createRoot($availability[0]);
    
    root.render(<Availability
        iPlannerAvailable={$availability.data('iplanner')}
        propertyName={$availability.data('property-name')}
        propertySlug={$availability.data('property-slug')}
        onDatesChanged={(from, to) => {
          $('#property_enquire').removeClass('disabled')
          $('#property_enquiry_from').val(from.format("DD/MM/YYYY"))
          $('#property_enquiry_until').val(to.format("DD/MM/YYYY"))
        }
      } />)
  }
})

const AvailabilityData = () => {
  return (window as any).Availability
}

interface ItineraryData {
  name: string
  slug: string
  date: string
  nights: number
}

interface AvailabilityProps {
  iPlannerAvailable: boolean
  propertyName: string
  propertySlug: string
  onDatesChanged: (from, to) => void
}

interface AvailabilityState {
  from: Date | null
  to: Date | null
  itineraries: ItineraryData[]
  showLoadModal: boolean
  mobile: boolean
}

class Availability extends React.Component<AvailabilityProps, AvailabilityState> {
  static get defaultProps() {
    return {
      onDatesChanged: (from, to) => {},
      propertyName: '',
      propertySlug: ''
    }
  }

  constructor(props: AvailabilityProps) {
    super(props)
    this.setupBeginItineraryHook()

    this.state = {
      from: null,
      to: null,
      itineraries: [],
      showLoadModal: false,
      mobile: false
    }

    this.handleDayClick = this.handleDayClick.bind(this)
    this.handleCloseModal = this.handleCloseModal.bind(this)
    this.newItinerary = this.newItinerary.bind(this)
    this.loadItinerary = this.loadItinerary.bind(this)
  }

  updateMobileState() {
    let mobile = false
    if (window.innerWidth < 960) {
      mobile = true
    }

    this.setState({
      mobile: mobile
    })
  }

  componentDidMount() {
    window.addEventListener("resize", this.updateMobileState.bind(this))
    this.updateMobileState()
  }

  componentWillMount() {
    if (AvailabilityData()) {
      this.setState({
        itineraries: AvailabilityData().itineraries || []
      })
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateMobileState.bind(this))
  }

  setupBeginItineraryHook() {
    if (AvailabilityData()) {
      AvailabilityData().beginItinerary = this.newItinerary.bind(this)
    }
  }

  itineraryPath() {
    return `/iplanner/new?property=${this.props.propertySlug}`
  }

  loadItinerary() {
    this.setState({
      showLoadModal: true
    })
  }

  newItinerary() {
    const { from, to } = this.state

    Mixpanel.track('New Itinerary', {
      choose_dates: from && to
    })

    setTimeout(() => {
      if (from && to) {
        const nights = moment(to).diff(moment(from), 'days')
        window.location.href = this.itineraryPath() + `&date=${moment(from).format('YYYY-MM-DD')}&nights=${nights}`
      } else {
        window.location.href = this.itineraryPath()
      }
    }, 300)
  }

  handleDayClick(day) {
    const self = this
    const range = DayPicker.DateUtils.addDayToRange(day, this.state);
    
    this.setState({
      from: range.from,
      to: range.to
    }, () => {
      self.props.onDatesChanged(moment(range.from), moment(range.to))
    });
  }

  handleCloseModal() {
    this.setState({
      showLoadModal: false
    })
  }

  render() {
    const { from, to, itineraries, showLoadModal, mobile } = this.state
    const iPlanner = this.props.iPlannerAvailable

    const disabledDays = [
      { before: new Date() },
      new Date()
    ]

    return (
      <div className="property-availability">
        <DayPicker
          fromMonth={moment().toDate()}
          toMonth={moment().add(18, 'months').toDate()}
          numberOfMonths={mobile ? 1 : 3}
          selectedDays={[from, { from, to }]}
          onDayClick={this.handleDayClick}
          disabledDays={disabledDays}
          fixedWeeks
        />
        <br />

        { iPlanner && itineraries.length > 0 ? <p>You have {itineraries.length} saved itineraries for this property. To load or start a new itinerary please click below.</p> : undefined }

        { iPlanner ? <div className="property-itinerary-buttons">
          { itineraries.length == 0 ? <a href="javascript:void(0)" className="button block-pad" onClick={this.newItinerary}>Begin Your Itinerary</a> : undefined }


          { itineraries.length > 0 ? <a href="javascript:void(0)" className="button hollow block-pad mg-r" onClick={this.loadItinerary}>Saved Itineraries</a> : undefined }
          { itineraries.length > 0 ? <a href="javascript:void(0)" className="button block-pad" onClick={this.newItinerary}>Start New Itinerary</a> : undefined }
        </div> : undefined }

        <Modal
          className="property-itineraries-modal"
          isOpen={showLoadModal}
          onRequestClose={this.handleCloseModal}
          overlayClassName="modal-underlay"
          ariaHideApp={false}
        >
          <a href="javascript:void(0)" onClick={this.handleCloseModal} className="modal-close"><i className="fa fa-times"></i></a>

          <div className="row">
            <div className="small-12 columns text-center">
              <h2 className="mg-b">My { this.props.propertyName } Itineraries</h2>
              
              <table className="unstriped">
                <tbody>
                  { itineraries.map(i => {
                    return (
                      <tr key={ i.slug }>
                        <td>{ i.name }</td>
                        <td>{ moment(i.date).format('Do MMMM YYYY') }</td>
                        <td>{ i.nights } Nights</td>
                        <td><a href={`/iplanner/${i.slug}/edit`} className="button small hollow">Load</a></td>
                      </tr>
                    )
                  }) }
                </tbody>
              </table>
            </div>
          </div>
        </Modal>
      </div>
    )
  }
}